import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import fox from './fox.svg';
import Swiper from 'swiper';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

const data = require('./data.json');
const useStyles = makeStyles((theme) => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: '2px solid #000',
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3)
	}
}));
let diff = 0;
const Review = ({ list }) => {
	const classes = useStyles();
	const [ open, setOpen ] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const [ currentId, setCurrentId ] = useState(0);
	
	const getMenu = (i) => {
		if (i >= 0 && i < 50) {
			diff = 0;
			return '0-50'
		} else if (i >= 50 && i < 100) {
			diff = 50;
			return '51-100'
		} else if (i >= 100 && i < 150) {
			diff = 100;
			return '101-150'
		} else if (i >= 150 && i < 200) {
			diff = 150;
			return '151-200'
		} else if (i >= 200 && i < 250) {
			diff = 200;
			return '201-250'
		} else if (i >= 250 && i < 300) {
			diff = 250;
			return '251-300'
		} else if (i >= 300 && i < 350) {
			diff = 250;
			return '301-350'
		} else if (i >= 350 && i < 400) {
			diff = 300;
			return '351-400'
		} else if (i >= 400 && i < 450) {
			diff = 350;
			return '401-450'
		} else {
			diff = 450;
			return '451-482'
		}
	};
	const content = (i) => {
		const menu = getMenu(i);
		const quiz = data[menu][i - diff];
		return (
			<div key={quiz.id} className="securityPlus-content">
				<small>Question {parseInt(quiz.id) + 1}</small>
				<h3>{quiz.question}</h3>
				<br />
				{Object.keys(quiz['options']).map((key, p) => (
					<h3 className="p-0 pl-3" key={p}>
						{key}: {quiz['options'][key]}
					</h3>
				))}
				<h3>Answer: {quiz.answer}</h3>
			</div>
		);
	};

	const prev = () => {
		if (currentId > 0) {
			setCurrentId(currentId - 1);
		}
	};

	const next = () => {
		if (currentId < list.length - 1) {
			console.log(currentId)
			setCurrentId(currentId + 1);
		}
	};

	return (
		<div>
			<Button onClick={handleOpen} className="review-button" variant="outlined">
				Review List
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500
				}}
			>
				<Fade in={open}>
					<Grid container spacing={3} className={classes.paper}>
						<Grid item xs={1}>
							<IconButton onClick={() => prev()}>
								<NavigateBeforeIcon />
							</IconButton>
						</Grid>
						<Grid item xs={10}>
							{list.length > 0 ? content(list[currentId]) : null}
						</Grid>
						<Grid item xs={1}>
							<IconButton onClick={() => next()}>
								<NavigateNextIcon />
							</IconButton>
						</Grid>
					</Grid>
				</Fade>
			</Modal>
		</div>
	);
};
export default Review;
